import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto  p-6 rounded-lg shadow-lg">
        <h1 className="text-3xl font-semibold text-gray-800 mb-6">
          Privacy Statement
        </h1>
        <p className="text-gray-700 mb-4">
          Your privacy is important to us. This Privacy Statement applies to
          collection, use, and disclosure of personal information through all of
          the sites, products, services and developer modules offered by
          Ayanshtech Solution Pvt Limited Inc. or its subsidiaries or affiliated
          companies that link to this Privacy Statement, including{" "}
          <a href="https://ayanshtechnology.com" className="text-blue-500">
            https://ayanshtechnology.com
          </a>
          . It does not apply to sites or services that link to different
          privacy statements.
        </p>
        <p className="text-gray-700 mb-4">
          Sometimes, we may post product specific privacy notices or Help Center
          materials to explain our products and related privacy policies in more
          detail. This Privacy Statement does not apply to the activities of our
          customers that use our services to collect information from their end
          users (the “Ayanshtech Solution Pvt Limited Customers”). Each of the
          Ayanshtech Solution Pvt Limited Customers are responsible for
          establishing their own privacy statement that describes those
          activities.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
          Information we collect and how we use it
        </h2>
        <p className="text-gray-700 mb-4">
          The personal information we collect depends on how you interact with
          us, the products you use, and the choices you make. We collect and
          process personal information about you with your consent and/or as
          necessary to provide the products you use, operate our business, meet
          our contractual and legal obligations, protect the security of our
          systems and our customers, or fulfill other legitimate interests.
        </p>
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Information you provide
        </h3>
        <ul className="list-disc list-inside text-gray-700 mb-6">
          <li>
            Contact information: When you sign up for an Ayanshtech Solution Pvt
            Limited Account, we ask you for personal information such as name,
            email address, and other information.
          </li>
          <li>
            Demographic data: When you register or at other times, we request
            that you provide demographic details.
          </li>
          <li>
            Content and files: We also collect information and files you send to
            us, should you choose to contact us through our customer support or
            related contact information.
          </li>
        </ul>
        <ul className="list-disc list-inside text-gray-700 mb-6">
          <li>
            Identifiers and device information: Automatically logging your
            computer’s operating system, IP address, access times, and
            information about your device, such as device identifiers (e.g., MAC
            address).
          </li>
          <li>
            Usage data: Logging your activity on our websites and connected
            services, including the URL of the website from which you came.
          </li>
          <li>
            Information we create or generate: Inferences based on other data we
            collect, such as location inferred from IP address.
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Third-party sources
        </h3>
        <p className="text-gray-700 mb-4">
          We may obtain information from third parties. We process information
          obtained from third parties as described in this statement, plus any
          additional restrictions imposed by the source of the information.
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-6">
          <li>
            Data sources that provide us with marketing leads or customer
            referrals.
          </li>
          <li>
            Third-party partners, such as social networks or applications that
            make users’ information available.
          </li>
          <li>
            Partners with which we offer co-branded services or joint marketing
            activities.
          </li>
          <li>
            Publicly-available sources, such as open government databases.
          </li>
        </ul>

        <h2 className="text-3xl font-bold mb-4">
          Cookies and Similar Technologies
        </h2>
        <p className="mb-4">
          We use cookies and similar technologies to operate our websites and
          online services and provide features, personalize content and
          advertising, analyze traffic, and help to collect data. Cookies are
          small text files placed on your device to store data that can be
          recalled by a web server in the same domain that placed the cookie.
          The text in a cookie often consists of a string of numbers and letters
          that uniquely identifies your device, but it can contain other
          information as well. We use cookies on our websites to store your
          preferences and settings, enable you to sign in, provide
          interest-based advertising, combat fraud, analyze how our products
          perform, and fulfill other legitimate purposes.
        </p>
        <p className="mb-4">
          Our web pages may also contain electronic images known as web beacons
          that we use to help deliver cookies on our websites, count users who
          have visited those websites, and gather usage and performance data. We
          also include web beacons in our email messages or newsletters to
          determine whether you open and act on them.
        </p>
        <p className="mb-4">
          Our websites may include web beacons and cookies from third-party
          service providers. In some cases, that is because we have hired the
          third party to provide services on our behalf, such as site analytics.
          In other cases, it is because our web pages contain content or ads
          from third parties, such as videos, news content, or ads delivered by
          other ad networks. Because your browser connects to those third
          parties’ web servers to retrieve that content, those third parties are
          able to set or read their own cookies on your device and may collect
          information about your online activities across websites or online
          services. These third parties may combine this information with other
          information that you’ve provided to them or that they’ve collected
          from your use of their services.
        </p>
        <p className="mb-4">
          This information is used to store your preferences and settings,
          enable you to sign in, analyze how our websites and apps perform,
          track your interaction with the site or app, develop inferences,
          deliver advertising, combat fraud, and fulfill other legitimate
          purposes. We and/or our partners also share the information we collect
          or infer with third parties for these purposes.
        </p>
        <p className="mb-4">
          The third-party analytics providers we use include: Marketo, Hubspot,
          Bizible, Google, Crazy Egg, New Relic, and Disqus. Many third-party
          analytics providers allow you to opt-out from their collection or use.
          For more information, click on the links above.
        </p>
        <p className="mb-4">
          Our third-party advertising partners include: Facebook, Google,
          Twitter, G2Crowd, and LinkedIn. You may find more information on each
          company’s practices, including the choices it offers, by clicking on
          the above.
        </p>
        <p className="mb-4">
          You can also use browser controls to limit how the websites you visit
          are able to use cookies. Instructions for blocking or deleting cookies
          may be available in each browser’s privacy or help documentation.
          Please be aware that if you choose to block cookies, certain website
          features that depend on cookies may no longer function. If you choose
          to delete cookies, settings and preferences controlled by those
          cookies, including advertising preferences, may be deleted and may
          need to be recreated.
        </p>

        <h2 className="text-3xl font-bold mb-4">
          California "Do Not Sell My Info"
        </h2>
        <p className="mb-4">
          The California Consumer Protection Act (“CCPA”) requires us to
          disclose categories of personal information sold to third parties and
          how to opt-out of future sales. The CCPA defines personal information
          to include online identifiers, including IP address, cookies IDs, and
          mobile IDs. The law also defines a “sale” to include simply making
          data available to third parties in some cases. We let advertising and
          analytics providers collect IP addresses, cookie IDs, mobile IDs
          through our sites and apps when you use our online services, but do
          not “sell” any other types of personal information.
        </p>
        <p className="mb-4">
          If you do not wish for us or our partners to “sell” your personal
          information to third parties for advertising purposes, you can make
          your Do Not Sell Request by visiting the links set out above.
        </p>
        <p className="mb-4">
          Note that although we will not “sell” your personal information after
          you exercise the choices at those links, we will continue to share
          some personal information with our partners (acting as our service
          providers) to help us perform advertising-related functions such as,
          but not limited to, measuring the effectiveness of our ads, managing
          how many times you may see an ad, reporting on the performance of our
          ads, ensuring services are working correctly and securely, providing
          aggregate statistics and analytics, improving when and where you may
          see ads, and/or reducing ad fraud. Further, exercising this choice
          will not necessarily opt you out of the use of previously sold
          personal information or stop all interest-based advertising.
        </p>
        <p className="mb-4">
          If you access this site (or app) from other devices or browsers, visit
          the links above from those devices or browsers to ensure your choice
          applies to the data collected when you use those devices or browsers.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
          Contact Us
        </h2>
        <p className="text-gray-700">
          If you have any questions or concerns regarding this Privacy Statement
          or your personal data, feel free to contact us at{" "}
          <a
            href="mailto:support@ayanshtechnology.com"
            className="text-blue-500"
          >
            info@ayanshtechnology.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
